<template>
  <div class="commondity-list-view root-box" :class="{ showNavBar }">
    <!-- 顶部页签 -->
    <top-meta :titleName="parentName" @lastPage="lastPage" :showSearch='true' :shopId='shopId'></top-meta>
    <!-- 水平导航栏 -->
    <menu-nav ref="menuNav" :menuCategory='menuCategory' :getResultType='getResultType' :clickIndex='clickIndex' :sortIndex='sortIndex' :selectedSortList='selectedSortList'></menu-nav>
    <!-- 商品展示区 -->
    <commodity-group ref="CommodityGroup" :categoryList='categoryList' :shopId='shopId' :appCont='appCont' :isLastPage='isLastPage' :isShowNoResult='isShowNoResult'></commodity-group>
  </div>
</template>

<script>
import Vue from "vue";
import YunJi from '@/assets/js/YunJi'
import * as Util from '@/assets/js/Util.js';
import * as commodityHttp from '@/pages/commodity/api/commodityList'
import * as MarkeUtil from '@/pages/commodity/common/MarkeLabelUtil.js'

import TopMeta from '@/pages/commodity/components/topMeta'
import MenuNav from './components/MenuNav'
import CommodityGroup from './components/CommodityGroup'
export default {
  data() {
    return {
      showNavBar: YunJi.showNavBar(),
      appCont: YunJi.getUrlParams('appCont'), //H5、app
      shopId: YunJi.getUrlParams('shopId'), // 店铺Id
      isAndroid:false,
      menuCategory:[], //三级类目
      categoryLevelId2: YunJi.getUrlParams('categoryId'), //二级类目Id
      categoryLevelId3: YunJi.getUrlParams('categoryLevelId'), //三级类目Id
      parentName: '', //三级类目名称
      categoryList: [],
      markedBuyAttachItemList: [], //打标买赠商品列表
      currPage: 0, //当前页
      pageSize: 10,//每页条数
      loading: false, //是否加载完成
      selectedSortList:['默认排序','价格由低到高','价格由高到低'],
      
      isLastPage: false, //是否是最后一页
      orderType: '', //排序方式 priceup价格由低到高 pricedown价格由高到低 不传就是默认
      moreUlList: [],
      isShowNoResult: false,
      clickIndex : 0,
      sortIndex: 0,
      timeout: -1, //清除定时器时间,
      pageId: '00062',
      itemTimeIds: "",
      idsTimeLength: null,
      idsListName: null,
      consignmentImg:'',// 代销图标
      ownSupportImg:'',// 自营图标
      // markList: [],
      getResultType: 0, // 0 默认  1 价格由低到高 2 价格由高到低
    }
  },
  components: {
    TopMeta,
    MenuNav,
    CommodityGroup
  },
  beforeRouteEnter(to,from,next) {
    next();
  },
  beforeRouteLeave(to,from,next) {
    next();
    this.clearData();
  },
  activated() {
    this.init(); //首次进入页面调用的方法
    YunJi.getMarkConfig();
  },
  mounted() {
    
  },
  methods: {
    lastPage() {
      history.back()
    },
    /**
    * 初始化数据
    */
    init() {
      this.shopId = YunJi.getUrlParams('shopId');//店铺id
      this.categoryLevelId2= YunJi.getUrlParams('categoryId'); //二级类目Id
      this.categoryLevelId3= YunJi.getUrlParams('categoryLevelId'); //三级类目Id
      this.currPage = 0;
      this.getResultType = 0;
      this.$nextTick(()=>{
        this._initCategoryData();
        // this.categoryInfo();
      })
    },
    /**
     * 获取三级菜单数据
     * categoryLevelId2 二级类目Id
     */
    _initCategoryData() {
      let params = {
        parentId: this.categoryLevelId2,
        appCont: this.appCont,
        t: new Date().getTime()
      };
      commodityHttp.getThirdCategory(params).then(res => {
        if(res.errorCode == Util.ERR_CODE && res.data && !YunJi.isEmptyObj(res.data)){
            this.categoryLevelData = res.data.categoryData;
            this.parentName = this.categoryLevelData[0].categoryLevelName;
            this.menuCategory = res.data.categoryData[0].childList;
            this.$nextTick(()=>{
              this.menuCategory.forEach((item,index) => {
                if(item.categoryLevelId == this.categoryLevelId3){
                  this.clickIndex = index;
                }
              });
              this.$refs.menuNav._initMenuScroll();
              this.$refs.menuNav.initSlide();
              this.$refs.menuNav.setDefaultActivityTimeId();
              this.categoryInfo();
            });
        }
      });
    },
    /**
     * 返回上一页,清楚当前页的数据
     */
    clearData(){
      this.clickIndex = 0;
      this.menuCategory = [];
      this.categoryList = [];
      this.orderType='';
      this.categoryLevelId2 = null;
      this.categoryLevelId3 = null;
      this.isShowNoResult = false;
    },
    /**
     * 切换类目
     */
    selectedSortLabel(event,index,categoryLevelId) {
      this.clickIndex = index;
      this.currPage = 0;
      this.categoryList = [];
      this.categoryLevelId3 = categoryLevelId;
      this.$refs.menuNav.isShowSort = false;
      this.categoryInfo();
       this.$refs.menuNav.calcSroll(event.target, index);
    },
    /**
     * 排序
     */
    selectedSort(index) {
      this.sortIndex = index;
      this.currPage = 0;
      this.categoryList = [];
      switch(index) {
        case 0:
          this.orderType = '';
          this.getResultType = 0;
          break;
        case 1:
          this.orderType = 'priceup';
          this.getResultType = 1;
          break;
        case 2:
          this.orderType = 'pricedown';
          this.getResultType = 2;
          break;
      }
      this.categoryInfo();
    },
    /**
     * 根据类目获取商品
     * 三级类目ID
     */
    categoryInfo() {
      let params = {
        userType: 2,
        categoryLevelId3: this.categoryLevelId3,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
        appCont: this.appCont
      };
      if(this.orderType){
        params.orderType = this.orderType
      }
      // categoryHttp.getCategoryInfo(params).then(res => {
      commodityHttp.getListItemByCategoryId(params).then(res => {
        if(res.errorCode == Util.ERR_CODE){
          if(res.data.totalCount == 0){
            this.isShowNoResult = true;
            this.categoryList = [];
          }else {
            this.isShowNoResult = false;
            let itemIds = '',itemId_num = ''; // 定义获取的商品ID集合
            let itemListLength = res.data; // 定义全局商品列表
            res.data.itemList.forEach((item,index) => {
              
              if(item.itemImgBig){
                item.itemImgBig = item.itemImgBig.split(";")[0];
              }
              this.categoryList.push(item); //搜索结果-列表
              itemId_num += res.data.itemList[index].itemId + ','; // 取出商品ID字符串
            });
            itemIds = itemId_num.substring(0,itemId_num.length-1); // 去除最后一个逗号,遍历成新的商品ID字符串
            this.$nextTick(()=>{
              if(this.categoryList&&this.categoryList.length>0){
                this.categoryList = MarkeUtil.setMarkeLabelByItemsListNew(this.categoryList,false,this.appCont,6);
              }
              //获取总页数
              this.getTotalPage(res.data.totalCount);
            });
          }
        }
      });
    },
    /**
     * 获取总页数
     * @param totalCount 数据总条数
     * @param pageSize 每页条数
     */
    getTotalPage(totalCount){
      let totalPage = Math.ceil(totalCount / this.pageSize);//总页数
      if((parseInt(this.currPage) + 1) >= totalPage){
        this.currPage = totalPage;
      }
      this.isLastPage = totalPage == this.currPage ? true : false;
      this.loading = this.isLastPage == true ? true : false;
    },
    /**
     * 到底刷新-加载数据
     */
    loadItemListData(){
      if(this.isLastPage) return
      this.currPage++;
      this.loading = true;
      this.timeout = setTimeout(() => {
        this.categoryInfo();
      }, 1000);
    },
    
  }
};
</script>

<style lang="less" scoped>
@import '../../style/common.less';
</style>
<style lang="less">
html,body,#main{
  height: 100%;
  background: #fff;
}
::-webkit-scrollbar{
  width: 0;
}
</style>